<template lang="pug">

  div( id="wrapper" v-if="isLoggedIn" )
    div( id="psa-modal" v-if="showModal" )
      div( class="psa-modal-content" ) 
        p {{ psa }}
        p( class="text-right mb-0" )
          button( class="btn btn-primary" v-on:click="showModal = false" ) I understand

    span( v-if="loading" ) Loading...
    template( v-else )
      nav( class="navbar-default navbar-static-side" role="navigation" )
        div( class="sidebar-collapse" )
          div( class="logo" v-bind:class="navbarCollapsed && 'd-flex justify-content-center align-items-center p-8 logo-container-collapsed'" )
            img( v-if="navbarCollapsed" src="/img/logo-icon.png" alt="Moonpull" class="logo" )
            img( v-else src="./vendor/images/logo-white.png" alt="Moonpull" class="logo" )

          ul( id="side-menu" class="nav metismenu" )

              li( class="nav-header" )

                div( class="dropdown profile-element" )
                  a( class="account-image" href="#" v-on:click.prevent="() => null" )
                    img( class="img-circle" alt="image" src="./vendor/images/user-default.jpg" width="48" height="48" )

                  span( class="account-name" ) {{ $moonpull.getCurrentUserSession().name }}

                  strong( class="account-type text-muted" )
                    | {{ $moonpull.getCurrentUserSession().title }}, {{ $moonpull.getCurrentUserSession().company.name }}

                  a( class="dropdown-toggle account-dropdown" data-toggle="dropdown" href="#" )

                  a( v-if="false" class="text-muted account-edit" href="#" v-on:click.prevent="() => null" )
                    i( class="fa fa-edit" aria-hidden="true" )

              li( v-for="link in links" )
                template( v-if="hasAccessToLink(link)" )
                  router-link(
                    v-if="link.sub === undefined"
                    v-bind:to="link.url"
                    class="nav-link-flex"
                  )
                    span
                      template(v-if="typeof link.icon === 'object' && link.icon.img")
                        img(:src="link.icon.img" alt="icon" class="nav-img-icon")
                      template(v-else)
                        i( v-bind:class="[ 'fa', link.icon, 'nav-icon' ]" )
                      span( class="nav-label" ) {{ link.label }}

                  template( v-else )
                    a(
                      href="#"
                      v-on:click.prevent="link.expanded = ! link.expanded; links = { ...links } /* <- hack to force re-render */"
                    )
                      template(v-if="typeof link.icon === 'object' && link.icon.img")
                        img(:src="link.icon.img" alt="icon" class="nav-img-icon" style="width:18px;height:18px;margin-right:17px;" )
                      template(v-else)
                        i( v-bind:class="[ 'fa', link.icon ]" )
                      span( class="nav-label" ) {{ link.label }}
                      span( class="fa fa-angle-down" )
                    
                    ul( class="nav nav-second-level collapse" v-bind:class="{ 'in': link.expanded }" )
                      li( v-for="subLink in link.sub" )
                        template( v-if="hasAccessToLink(subLink)" )
                          router-link( v-bind:to="subLink.url" )
                            template(v-if="typeof subLink.icon === 'object' && subLink.icon.img")
                              img(:src="subLink.icon.img" alt="icon" class="nav-img-icon" style="width:18px;height:18px;margin-right:6px;" )
                            template(v-else)
                              i( v-bind:class="[ 'fa', subLink.icon ]" )
                            span( class="nav-label" ) {{ subLink.label }}

      div( id="page-wrapper" class="gray-bg dashboard-1" )
        div( class="row" )
          nav( class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0;" )
            div( class="navbar-header" )
              a( class="navbar-minimalize minimalize-styl-2" href="#" )
                i( class="fa fa-bars" v-on:click="toggleNavbarCollapse" )

            ul( class="nav navbar-top-links navbar-right" )
              li( v-if="showToFromLocalLink()" )
                a( v-if="isLocal()" class="block" v-bind:href="`https://app.mnpll.com/#${$route.path}`" )
                  i( class="fa fa-globe" ) To Prod
                a( v-else class="block" v-bind:href="`http://localhost:8080/#${$route.path}`" )
                  i( class="fa fa-laptop" ) To Local
              
              li
                router-link( class="block" id="logout-link" to="/logout" )
                  i( class="fa fa-sign-out" ) Log out

        router-view( class="animated fadeIn" v-bind:key="$route.path" )
      
  div( id="wrapper" v-else )
    router-view( class="animated fadeIn" v-bind:key="$route.path" )

</template>

<style lang="scss">
// INSPINIA theme requirements
@import url("./vendor/css/bootstrap.min.css");
@import url("./vendor/font-awesome/css/font-awesome.css");
@import url("./vendor/css/animate.css");
@import url("./vendor/css/style.css");
@import url("./vendor/css/custom.css");

.nav-header {
  color: #fff;

  #logout-link {
    cursor: pointer;
  }
}

.logo {
  max-width: 100%;
}

.logo-container-collapsed {
  height: 50px;
  padding: 18px;
}

.navbar-static-side {
  z-index: 0 !important;
}

#db-indicator {
  position: fixed;
  top: 0;
  left: 50%;
  background-color: #ec7211;
  color: #fff;
  padding: 5px 10px;
  z-index: 10000;
}
#psa-modal {
  display: flex;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  align-items: top;
  justify-content: center;
}

.psa-modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  margin-top: 7%;
  border: 1px solid #888;
  width: 20%;
  align-items: center;
  position: fixed;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  right: 10px;
  top: 5px;
}

.close:hover,
.close:focus {
  color: #000;
  cursor: pointer;
}

.nav-img-icon {
  margin-left: -35px;
  margin-right: 8px; // Adjust as needed for spacing between icon and text
  vertical-align: middle;
  width: 18px;
  height: 18px;
}

.nav-label {
  display: inline-block;
  vertical-align: middle;
}

.nav-icon,
.nav-link-flex {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
  text-decoration: none;
}
</style>

<script>
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      loading: true,
      isLoggedIn: false,
      navbarCollapsed: false,
      showModal: false,
      psa: null,
      links: [
        { label: "Your Results", url: "/reporting", icon: "fa-bar-chart-o" },
        {
          label: "Advertiser Search",
          url: "/reporting/audits",
          icon: "fa-search",
        },
        { label: "Submit Links", url: "/link-checker", icon: "fa-link" },
        {
          label: "Account",
          url: "#",
          icon: "fa-users",
          companyOwner: true,
          sub: [
            {
              label: "Companies Management",
              url: "/companies",
              icon: "fa-building",
              superAdmin: true,
            },
            { label: "User Management", url: "/users", icon: "fa-users" },
          ],
        },
        {
          label: "CMS",
          url: "#",
          icon: "fa-cog",
          superAdmin: true,
          sub: [
            { label: "Documentation", url: "/documentation", icon: "fa-book" },
            {
              label: "Platform Content",
              url: "/cms/platform-content",
              icon: "fa-pencil",
              superAdmin: true,
            },
            {
              label: "Networks (Classic)",
              url: "/cms/networks",
              icon: "fa-server",
              superAdmin: true,
            },
            {
              label: "Networks",
              url: this.$moonpull.nuxtUrl('/admin/networks'),
              icon: "fa-server",
              superAdmin: true,
            },
            {
              label: "CMPs",
              url: "/cms/lite-cmp",
              icon: "fa-database",
              superAdmin: true,
            },
            {
              label: "Narrative Management",
              url: "/narrative-management",
              icon: "fa-comments",
              superAdmin: true,
            },
            {
              label: "Error Management",
              url: "/error-management",
              icon: "fa-bug",
              superAdmin: true,
            },
            {
              label: "Reasons Management",
              url: "/reasons-management",
              icon: "fa-sticky-note",
              superAdmin: true,
            },
            {
              label: "Statuses",
              url: "/cms/statuses",
              icon: "fa-info-circle",
              superAdmin: true,
            },
            {
              label: "Access Control",
              url: "/cms/access",
              icon: "fa-users",
              superAdmin: true,
            },
            {
              label: "Advertiser Certification Responsibility",
              url: "/cms/certification-responsibility",
              icon: "fa-users",
              superAdmin: true,
            },
            {
              label: "Guided Results",
              url: "/cms/guided-results",
              icon: "fa-sticky-note",
              superAdmin: true,
            },
            {
              label: "Whitelist",
              url: "/cms/whitelist",
              icon: "fa-sticky-note",
              access: () =>
                this.$moonpull.currentUserHasAccessTo("whitelisting"),
            },
            {
              label: "Moonpull reporting",
              url: "/cms/moonpull-reporting",
              icon: "fa-sticky-note",
              superAdmin: true,
            },
          ],
        },
        {
          label: "Network Insights",
          url: "#",
          icon: "fa-server",
          superAdmin: true,
          sub: [
            {
              label: "Advertiser Upload",
              url: "/network-insights/submission",
              icon: "fa-upload",
              superAdmin: true,
            },
          ],
        },
        {
          label: "Moonpull Share",
          url: "#",
          icon: { img: require("@/assets/Moonpull-Share-onblack.png") },
          access: () => this.$moonpull.currentUserHasShareAccess(),
          sub: [
            {
              label: "Report Queue",
              url: "/share/issues/reports",
              icon: "fa-list",
              superAdmin: true,
            },
            {
              label: "Issues",
              url: "/share/issues",
              icon: "fa-info-circle",
            },
          ],
        },
        {
          label: "Internal Issue Queue",
          url: "/internal-advertiser-issue-queue",
          icon: "fa-exclamation-circle",
          superAdmin: true,
        },
        {
          label: "API Keys",
          url: "/api-keys",
          icon: "fa-key",
          access: () => this.$moonpull.currentUserHasAccessTo("api"),
        },
        {
          label: "Advertiser Management",
          url: "/cms/advertisers",
          icon: "fa-globe",
          access: () =>
            this.$moonpull.currentUserHasAccessTo("advertiserManagement"),
        },
        {
          label: "Moonpull Reporting",
          url: "/moonpull-reporting",
          icon: "fa-book",
          superAdmin: true,
        },
        {
          label: "Enterprise Reporting",
          url: "/enterprise-reporting",
          icon: "fa-book",
          access: () =>
            this.$moonpull.currentUserIsSuperAdmin() ||
            !this.$moonpull.currentUserHasAccessTo("enterpriseReporting"),
        },
        {
          label: "Superuser Tools",
          url: "/superuser-tools",
          icon: "fa-lock",
          superAdmin: true,
        },
        {
          label: "Scheduling",
          url: "/scheduling",
          icon: "fa-calendar",
          access: () =>
            this.$moonpull.currentUserIsSuperAdmin() ||
            !this.$moonpull.currentUserHasAccessTo("scheduling"),
        },
        {
          label: "Support",
          url: "/support",
          icon: "fa-book",
          superAdmin: false,
        },
        {
          label: "Link Assurance",
          url: "/link-assurance",
          icon: "fa-link",
          superAdmin: true,
        },
        {
          label: "Link Assurance Search",
          url: "/link-assurance-search",
          icon: "fa-link",
          superAdmin: true,
        },
        {
          label: "Advertiser Certification",
          url: "/advertiser-certification",
          icon: "fa-link",
          superAdmin: true,
        },
      ],
    };
  },

  watch: {
    async $route() {
      this.isLoggedIn = await this.$moonpull.isLoggedIn();
    },

    async isLoggedIn() {
      if (this.isLoggedIn) {
        await this.loadAccessControl();
        await this.loadPSA();
        this.amplitudeIdentify();
      }
    },
  },

  methods: {

    isLocal() {
      return window.location.hostname === "localhost";
    },

    showToFromLocalLink() {
      return [
        "olliesu@moonpullpartners.com",
        "jordansu@moonpullpartners.com",
      ].includes(this.$moonpull.getCurrentUserSession().email);
    },

    logout() {
      this.isLoggedIn = false;
      this.$moonpull.logout();
    },

    toggleNavbarCollapse() {
      const body = document.getElementsByTagName("body")[0];

      if (this.navbarCollapsed) {
        body.classList.remove("mini-navbar");
      } else {
        body.classList.add("mini-navbar");
      }

      this.navbarCollapsed = !this.navbarCollapsed;
    },

    hasAccessToLink(link) {
      return (
        // No restrictions
        (!link.access && !link.superAdmin && !link.companyOwner) ||
        // Super admin only
        (link.superAdmin && this.$moonpull.currentUserIsSuperAdmin()) ||
        // Company owner only
        (link.companyOwner && this.$moonpull.currentUserIsCompanyOwner()) ||
        // Access control
        (link.access && link.access())
      );
    },

    async loadAccessControl() {
      await this.$moonpull.loadAccessControl();
    },

    async loadPSA() {
      const platformContent = await this.$moonpull.getPlatformContent();
      this.psa = platformContent.psa;
      this.showModal = this.psa !== "";
    },

    amplitudeIdentify() {
      const user = this.$moonpull.getCurrentUserSession();
      if (user) {
        analytics.identify(user.id, {
          moonpullUserId: user.id,
          name: user.name,
          email: user.email,
          companyId: user.company.id,
          companyName: user.company.name,
        });
      }
    },
  },

  async beforeCreate() {
    // We want to redirect to maintenance page if server is offline
    if (await this.$moonpull.isServerDown()) {
      console.error(`Server is down`);
      window.location.href = `/maintenance.html${window.location.hash}`;
    }

    if (await this.$moonpull.isLoggedIn()) {
      await this.loadAccessControl();
      await this.loadPSA();
      this.amplitudeIdentify();
    }
    this.loading = false;
  },
});
</script>
